/**
 * queue #693 §UAT-2026-07-14-R693 §R693-3 — `dev-standards-viewer/components/StandardsDownloadButtons.tsx`
 * 안의 private 함수를 승격한 공유 유틸(호출부 2: `StandardsDownloadButtons` · `ModuleDocsModal`).
 * `Blob` + `createObjectURL` + 임시 `<a download>` + `revokeObjectURL` 표준 패턴 — 신규 구현 아님.
 */
export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
